// extracted by mini-css-extract-plugin
export default {"cropOption":"background-image-media-controls-module__cropOption--SZGcW","replaceOption":"background-image-media-controls-module__replaceOption--vdGVy"};